import {computed, unref, type MaybeRef} from 'vue'
import {IPointerDragPreviewData} from '@toolify/client/src/modules/ui/types/IPointerDragPreviewData'
import {requirePointerDragDrop} from '@toolify/client/src/modules/ui/composables/usePointerDragDrop'

export function useDragSource<T>(options: {
  payload: () => T
  preview: () => IPointerDragPreviewData
  disabled?: MaybeRef<boolean>
}) {
  const context = requirePointerDragDrop()
  const sourceId = Symbol('drag-source')
  const isDragging = computed(() => context.isDragging.value && context.activeSourceId.value === sourceId)

  function onPointerdown(event: PointerEvent) {
    if(unref(options.disabled)) {
      return
    }
    context.beginPotentialDrag(event, options.payload(), options.preview(), sourceId)
  }

  function onDragstart(event: DragEvent) {
    event.preventDefault()
  }

  return {
    sourceBindings: {
      pointerdown: onPointerdown,
      dragstart: onDragstart,
    },
    isDragging,
  }
}
